import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import {
  getEnquiriesSuccess,
  getEnquiriesFailure,
  searchJobIdUserRefSuccess,
  searchJobIdUserRefFailure,
  getTeamEnquirerListSuccess,
  getTeamEnquirerListFailure,
  getCredentialSuccess,
  getCredentialFailure
} from './actions';
import { HomeActionTypes } from './types';
import { getEnquiries, searchJobIdUserRef } from 'services/enquiry.service';
import { getTeamEnquirerList } from 'services/team.service';
import { getCredential } from 'services/user.service';

function* handleGetEnquiriesList(request: any) {
  try {
    const response: AxiosResponse = yield getEnquiries(request.payload);
    if (response) {
      yield put(getEnquiriesSuccess(response.data));
    } else {
      yield put(getEnquiriesFailure('Unable to get enquiries'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(getEnquiriesFailure(errMsg || 'Unable to get enquiries'));
  }
}

function* handleSearchUserIdUserRef(request: any) {
  try {
    const response: AxiosResponse = yield searchJobIdUserRef(request.payload);
    if (response) {
      yield put(searchJobIdUserRefSuccess(response.data));
    } else {
      yield put(searchJobIdUserRefFailure('Unable to get search data'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(searchJobIdUserRefFailure(errMsg || 'Unable to get search data'));
  }
}

function* handleGetTeamEnquirerList(request: any) {
  try {
    const response: AxiosResponse = yield getTeamEnquirerList(request.payload);
    if (response) {
      yield put(getTeamEnquirerListSuccess(response.data));
    } else {
      yield put(getTeamEnquirerListFailure('Unable to teams enquirer list'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(
      getTeamEnquirerListFailure(errMsg || 'Unable to teams enquirer list')
    );
  }
}

function* handleGetCredential() {
  try {
    const response: AxiosResponse = yield call(getCredential);
    if (response?.data) {
      yield put(getCredentialSuccess(response.data));
    } else {
      put(getCredentialFailure('Unable get crendetials'));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(getCredentialFailure(msg || 'Unable get crendetials'));
  }
}

function* watchGetEnquiriesList() {
  yield takeLatest(HomeActionTypes.GET_ENQUIRIES_START, handleGetEnquiriesList);
}

function* watchSearchJobIdUserRef() {
  yield takeLatest(
    HomeActionTypes.SEARCH_JOB_ID_USER_REF_START,
    handleSearchUserIdUserRef
  );
}

function* watchGetTeamEnquirerList() {
  yield takeLatest(
    HomeActionTypes.GET_TEAM_ENQUIRER_LIST_START,
    handleGetTeamEnquirerList
  );
}

function* watchGetCredential() {
  yield takeLatest(HomeActionTypes.GET_CREDENTIAL_START, handleGetCredential);
}

function* sagas() {
  yield all([
    call(watchGetEnquiriesList),
    call(watchSearchJobIdUserRef),
    call(watchGetTeamEnquirerList),
    call(watchGetCredential)
  ]);
}

export default sagas;
